import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
export default class {
	constructor() {

		this.init();
		this.single();
		this.cases();

		window.addEventListener('resize', () => {
			this.init();
		});
	}

	init() {
		const swiper = new Swiper('.js-bnr', {
			breakpoints: {
				1056: {
					loop: false,
					slidesPerView: 4,
					spaceBetween: 20,
					navigation: {
						nextEl: '.js-bnr__arw-next',
						prevEl: '.js-bnr__arw-prev',
						clickable: true,
					},
				},
			},
			speed: 400,
			spaceBetween: 0,
			slidesPerView: 2,
			spaceBetween: 15,
			loop: true,
			pagination: {
				el: '.js-bnr__pagination',
				type: 'bullets',
				clickable: true,
			},
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
		});
	}
	single() {
		const swiper = new Swiper('.js-interview', {
			// allowTouchMove: false,
			slidesPerView: 1,
			spaceBetween: 40,
			pagination: {
				el: '.js-interview__pagination',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: '.js-interview__arw-next',
				prevEl: '.js-interview__arw-prev',
			},
			breakpoints: {
				1056: {
					// slidesPerView: 2.3,
					slidesPerView: 2,
				},
			},
		});
	}
	cases() {
		let swiperInstance = null;

		const initializeSwiper = () => {
			swiperInstance = new Swiper('.js-cases', {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				speed: 400,
				pagination: {
					el: '.js-cases__pagination',
					type: 'bullets',
					clickable: true,
				},
			});
		};
		const checkAndInitSwiper = () => {
			if (window.matchMedia("(max-width: 1024px)").matches) {
				if (!swiperInstance) {
					initializeSwiper();
				}
			} else {
				if (swiperInstance) {
					swiperInstance.destroy(true, true);
					swiperInstance = null;
				}
			}
		};
		checkAndInitSwiper();
		window.addEventListener('resize', checkAndInitSwiper);
	}
}